import { GroupByFunctionReturnType, KeyMapType } from '@/types';

export function formatCurrency(num: number, positive?: string): string {
  if (!positive) {
    positive = '';
  }
  if (num) {
    let number = num.toString();

    let sign = number.indexOf('-') === 0 ? '-' : positive;
    if (sign === '-') {
      number = number.substr(1);
    }

    let cents = number.indexOf('.') > 0 ? number.substr(number.indexOf('.')) : '';
    cents = cents.length > 1 ? cents : '';

    number = number.indexOf('.') > 0 ? number.substring(0, number.indexOf('.')) : number;

    if (cents === '') {
      if (number.length > 1 && number.substr(0, 1) === '0') {
        return num.toString();
      }
    } else {
      if (number.length > 1 && number.substr(0, 1) === '0') {
        return num.toString();
      }
    }

    let tempNum = '';
    while (number.length > 3) {
      tempNum = ',' + number.slice(-3) + tempNum;
      number = number.slice(0, number.length - 3);
    }
    if (number) {
      tempNum = number + tempNum;
    }

    return sign + tempNum + cents;
  } else {
    return '0';
  }
}

export function htmlEncode(str: string): string {
  let res = '';
  if (str.length > 0) {
    res = str.replace(/&/g, '&amp;');
    res = res.replace(/</g, '&lt;');
    res = res.replace(/>/g, '&gt;');
    res = res.replace(/"/g, '&quot;');
    res = res.replace(/\'/g, '&#39;');
    res = res.replace(/\//g, '&#x2F;');
    res = res.replace(/`/g, '&#x60;');
    res = res.replace(/=/g, '&#x3D;');
  }
  return res;
}

export function htmlRestore(str: string): string {
  let res = '';
  if (str.length > 0) {
    res = str.replace(/&amp;/g, '&');
    res = res.replace(/&lt;/g, '<');
    res = res.replace(/&gt;/g, '>');
    res = res.replace(/&quot;/g, '"');
    res = res.replace(/&#39;/g, '\'');
    res = res.replace(/&#x2F;/g, '\/');
    res = res.replace(/&#x60;/g, '`');
    res = res.replace(/&#x3D;/g, '=');
  }
  return res;
}

import banks from '@/const/words/bank';
export function getBankName(code: string): string {
  return getEnumName(code, 'bank');
}
import countrys from '@/const/words/country';
export function getCountryName(code: string): string {
  return getEnumName(code, 'country');
}

import orderStatusType from '@/const/words/orderStatusType';
export function getOrderStatusTypeName(code: string): string {
  return getEnumName(code, 'orderStatusType');
}

export function getEnumName(code: string, type: string): string {
  let enumName = '';
  switch (type) {
    case 'bank':
      let tempBank = banks.find((bank: any): boolean => bank.value === code);
      if (tempBank) {
        enumName = tempBank.name;
      }
      break;
    case 'orderStatusType':
      let tempOrderStatusType = orderStatusType.find((orderStatusType: any): boolean => orderStatusType.value === code);
      if (tempOrderStatusType) {
        enumName = tempOrderStatusType.name;
      }
      break;
    case 'country':
      let tempCountry = countrys.find((bank: any): boolean => bank.value === code);
      if (tempCountry) {
        enumName = tempCountry.name;
      }
      break;
  }
  return enumName;
}

import metaTitles from '@/const/words/metaTitle';
export function getMetaTitle(vueEntity: any, code?: string): string {
  let defaultTitles = (metaTitles.find((item: any): boolean => item.code === 'default') as any).values;
  let locale = vueEntity.$i18n.locale;
  let titleLabel = defaultTitles[locale] ? defaultTitles[locale] : defaultTitles['kr'];
  if (code) {
    let metaTitle = metaTitles.find((item: any): boolean => item.code === code) as any;
    if (metaTitle) {
      let labels = metaTitle.values;
      titleLabel = labels[locale] ? labels[locale] : labels['kr'];
    }
  }
  return titleLabel;
}

export function getOptionNameAndValue(optionType: string, optionName: string, optionValue: string): string {
  let nameAndValueArray = [];
  let index = 0;
  let nameArray = [];
  let valueArray = [];
  if (optionType === 'COMBINATION') {
    nameArray = optionName.split('|');
    valueArray = optionValue.split('|');
    if (nameArray.length === valueArray.length) {
      index = nameArray.length;
    }
    for (let i = 0; i < index; i++) {
      let tempNameAndValue = nameArray[i] + ':' + valueArray[i];
      nameAndValueArray.push(tempNameAndValue);
    }
    return nameAndValueArray.join('|');
  } else if (optionType === 'DEFAULT') {
    return optionName;
  } else if (optionType === 'REQUIRED') {
    return `${optionName}:${optionValue}`;
  } else {
    return '';
  }
}
export function addProductDetailUrlPreview(url:string):string{
  const preview = 'preview=true';
  return url + (url.indexOf('?') >= 0 ? '&' : '?') + preview;
}

/**
 * key 값으로 data 를 묶는 함수
 * @param data: {}[] : 객체를 담은 배열 타입
 * @param key: data 에 존재하는 키값들 중 하나
 */
export const groupBy = <Data>(data: Data[], key: keyof Data): GroupByFunctionReturnType<Data> => {
  const dataMap = new Map<KeyMapType<Data>, Data>();
  data.forEach((d): Map<KeyMapType<Data>, Data> => dataMap.set(d[key].toString(), d));
  return dataMap
}
